import logoImage from "../../assest/images/logo-img.png"
import whiteLogoImage from "../../assest/images/whitelogo.png";
import { Link } from "react-router-dom";
import LastBox from "../../components/LastBox";
import helper from "../../common/Helper";
const Index = ({ state, login, changeValue, showPassword, handhandleShowPassword, isLoading, userlang }) => {
    const {
        error, email, password
    } = state;
    return (
        <section className="loginSec">
            <div className="loginpart">
                <div className="container">
                    <div className="loginBox">
                        <div className="logoSec">
                            <Link to={'/' + userlang} className='comLogo' ><img src={logoImage} alt="logo-img" /></Link>
                            <Link to={'/' + userlang} className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></Link>


                            <h4>Let’s login to your <br /> account first</h4>
                        </div>
                        <form onSubmit={login}>
                            <div className="fillDetails">
                                <ul>
                                    <li>
                                        <label className="commonLabel" htmlFor="">Email</label>
                                        <input className="commonInput" type="email" name="email" value={email} placeholder="Enter email" onChange={changeValue} />
                                        {error && error.email && <span className="cus-err">{error.email}</span>}
                                    </li>
                                    <li>
                                        <label className="commonLabel" htmlFor="">Password</label>
                                        <input className="commonInput" type={!showPassword ? 'password' : 'text'} name="password" value={password} placeholder="Enter Password" onChange={changeValue} />
                                        <button className="btn btnShow" type="button">
                                            {
                                                showPassword ? <i className="fa-solid fa-eye-slash" onClick={handhandleShowPassword}></i> : <i className="fa-solid fa-eye" onClick={handhandleShowPassword}></i>
                                            }


                                        </button>
                                        {error && error.password && <span className="cus-err">{error.password}</span>}
                                    </li>
                                </ul>
                                <div className="remember">
                                    <div className="checkBox">
                                        <div className="clickTo">
                                            <input type="checkbox" className="keyword-checkbox" />
                                            <label htmlFor="" className="keyword-label">Remember me</label>
                                        </div>
                                        <Link className="comYellowa" to={'/' + userlang + '/forgot-password'}>Forgot Password</Link>
                                    </div>
                                    <div className="loginBtn">
                                        <button
                                            className="btn common-btn btn-login"
                                            type="submit"
                                            disabled={isLoading}>

                                            {isLoading ? "Loading..." : "Login as Client"}
                                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}
                                        </button>
                                    </div>
                                    
                                    <div className="register">
                                        <p>Don’t have an account? <Link className="comYellowa" to={'/' + userlang + '/signup'}>Register Here</Link></p>
                                    </div>
                                       <div className="loginBtn">
                                        <button
                                            className="btn common-btn btn-login"
                                            type="button"
                                            onClick={()=> window.open(helper.supplierUrl, "_blank")}
                                           >
                                           Login as Tour Operator
                                           <i className="fa-solid fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <LastBox userlang={userlang} />
                </div>
            </div>
        </section>
    )

}
export default Index;
